import client from '@sanity/client'
export default client({
    projectId: '5qti9f0g',
    dataset: 'production',
    useCdn: true,
})
